import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function FacilityOrderTemplateItemNewFlowDeleteQuestionModalTemplate({ facilityOrderTemplateItemNewFlowDeleteQuestionModalStore}) {
    const {
        deleteFacilityOrdeTemplateItem,
        disabled,
        loadTemplate,
        loadTemplateItem,
        isNikoHealthModal
    } = facilityOrderTemplateItemNewFlowDeleteQuestionModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Delete item</h3>
            </div>
            <div className="modal__body">
                {
                    isNikoHealthModal ? 
                        <div>You are about to delete the last template item on this template. Do you want to delete the entire template, or only the template item?</div>
                        : <div>You are about to delete the last template item on the last template of a new patient. Do you want to delete the entire patient, or only the template item?</div>}
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={isNikoHealthModal ? "Delete the template" : "Delete the patient"}
                    onClick={() => deleteFacilityOrdeTemplateItem(true)}
                    disabled={disabled}
                    rotate icon={
                        loadTemplate
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label={"Delete only the template item"}
                    onClick={() => deleteFacilityOrdeTemplateItem(false)}
                    focused={true}
                    disabled={disabled}
                    rotate icon={
                        loadTemplateItem
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>
        </section>
    )
}
 
FacilityOrderTemplateItemNewFlowDeleteQuestionModalTemplate.propTypes = {
    facilityOrderTemplateItemNewFlowDeleteQuestionModalStore: PropTypes.object
};

export default defaultTemplate(FacilityOrderTemplateItemNewFlowDeleteQuestionModalTemplate);
